import CategoryView from "@/components/feature/CategoryView";

export default function EroticCategoryPage() {
  return (
    <CategoryView
      config={{
        type: "movie",
        crumb: "伦理电影",
        title: "伦理电影",
        description:
          "聚焦韩国伦理电影长片，涵盖爱情伦理、社会伦理、心理伦理等方向。你可以按类型、上映年份与评分区间筛选，快速找到想深入了解的剧情与影评。",
        meta: {
          title: "韩国伦理 - 伦理电影专题，最新韩国伦理电影推荐",
          description:
            "韩国伦理电影专题页，汇集最新与经典的韩国伦理电影，提供剧情介绍、评分与影评，支持按类型、年份、评分筛选浏览。",
          keywords: "韩国伦理电影,伦理电影,韩国伦理片,韩国电影推荐,伦理电影专题",
        },
      }}
    />
  );
}